import React from 'react'
import ReactDOM from 'react-dom'
import PrecentageApp from './_/number'
import './css/index.css'

ReactDOM.render(
  <PrecentageApp />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js